export default __webpack_public_path__ + "assets/mine.b801.svg";